import React from "react";
import { Navigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import TopConLogo from "@assets/company/TopconTheConcreteSuiteWhite.svg";
// endregion Imports - Assets
// region Imports - Atoms
import LoginBackground from "@atoms/LoginBackground";
// endregion Imports - Atoms
// region Imports - Molecules
import LoginForm from "@molecules/LoginForm";
// endregion Imports - Molecules
// region Imports - Hooks
import { useAuth } from "src/hooks/useAuth";
// endregion Imports - Hooks
// region Imports - Styles
import {
  LoginContainer,
  LoginFormContainer,
  LoginTelluriaGroupContainer
} from "./styles";
// endregion Imports - Styles

const Login: React.FC = () => {
  const { user } = useAuth();

  if (user) return <Navigate to="/" />;

  return (
    <LoginContainer>
      <LoginBackground />
      <LoginFormContainer>
        <LoginForm />
        <LoginTelluriaGroupContainer href="https://topconsuite.com/">
          <ReactSVG src={TopConLogo} />
        </LoginTelluriaGroupContainer>
      </LoginFormContainer>
    </LoginContainer>
  );
};

export default Login;
